export const SET_SELECTED_OFFER = 'SET_SELECTED_OFFER';
